import React from 'react';
import '../../../css/Form.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ERPUtils from "../../../helper/Utils"
import Select from 'react-select';
import ConfirmPopup from '../../../helper/ConfirmationPopup';

const PersonalDetails = (props) => {
	const {
		onChangeHandler,
		Genders,
		maritalStatus,
		Nationalities,
		Religions,
		bloodGroups,
		Reservations,
		DifferentlyAbledOpt,
		handleRenderComp,
		DateChangeHandler,
		SelectHandler,
		ValidationError,
		userDetails,
		topFunction,
		scrollToBottom,
		requiredFields,
		CountryCodes,
		GenerateRemovePopup,
		saveDraft,
		editable,
		// dashboardHandler,
		// LockDashboard,
		validateEmail,
		scrollHandler,
		isPassportRequired

	} = props;

	const [ageConfirmData, setAgeConfirmData] = React.useState({ show: false, date: null, msg: '' });

	function containsNumbers(str) {
		return /\d/.test(str);
	}

	return (
		<div className="appForm" id='APP-FORM' onScroll={scrollHandler} 
		style={{height:window.innerWidth>800 ? window.innerHeight-240 : window.innerWidth<=375?window.innerHeight-275:window.innerWidth<=425?window.innerHeight-260: window.innerHeight-260,overflowY:"auto"}}>
			<div className="animated zoomIn">
				<div className="row">
					<div className="col-md-6 col-sm-6">
						{/* <button
							className={LockDashboard ? 'disabledDashboardBtn' : 'backtoDashboardBtn'}
							onClick={dashboardHandler}
							disabled={LockDashboard}
						>
							<i className="fa fa-arrow-left backIcon" />Back to dashboard
						</button> */}
					</div>
					<div className="col-md-6 col-sm-6">
						<p className="requiredHeader ">
							<span className="requiredTextHeading">*</span> These fields are required
						</p>
					</div>
				</div>
				<div className="formWrapper">
					<div className="row">
						<div className="col-md-3 col-xs-12">
							<label className="appFormLabel ">
								Name
							</label>
							<span className="requiredText">*</span>
						</div>
						<div className="col-md-5 col-xs-12">
							<input
								required
								className={
									requiredFields.commonErrors[0].NameReqError ? (
										'form-control invalid z-depth-3'
									) : (
										'form-control z-depth-3'
									)
								}
								id="ConvertToupper"
								onChange={(e) => {
									if (!containsNumbers(e.target.value)) {
										onChangeHandler(e)
									}
								}}
								value={userDetails.Name}
								name="Name"
								type="text"
								placeholder="As per school records"
								maxLength="100"
								disabled={editable === false ? true : false}
							/>
							{requiredFields.commonErrors[0].NameReqError ? (
								<p className="ValidationError">
									<i className="fa fa-warning warningIcon" />Name cannot be empty
								</p>
							) : null}
						</div>
					</div>
				</div>

				<div className="formWrapper">
					<div className="row">
						<div className="col-md-3 col-xs-12">
							<label className="appFormLabel ">
								Gender
							</label>
							<span className="requiredText">*</span>
						</div>
						<div className="col-md-5 col-xs-12">
							<Select
								className={
									requiredFields.commonErrors[0].GenderReqError ? 'invalid z-depth-3' : 'z-depth-3'
								}
								value={userDetails.Gender}
								onChange={(selected) => SelectHandler(selected, 'Gender')}
								options={Genders}
							/>
							{requiredFields.commonErrors[0].GenderReqError ? (
								<p className="ValidationError">
									<i className="fa fa-warning warningIcon" />Gender cannot be empty
								</p>
							) : null}
						</div>
					</div>
				</div >

				<div className="formWrapper">
					<div className="row">
						<div className="col-md-3 col-xs-12">
							<label className="appFormLabel ">
								Father's Name
							</label>
						</div>
						<div className="col-md-5 col-xs-12">
							<input
								className="form-control z-depth-3"
								value={userDetails.FatherName}
								onChange={(e) => {
									if (!containsNumbers(e.target.value)) {
										onChangeHandler(e)
									}
								}}
								name="FatherName"
								type="text"
								maxLength="100"
							/>
						</div>
					</div>
				</div >

				<div className="formWrapper">
					<div className="row">
						<div className="col-md-3 col-xs-12">
							<label className="appFormLabel ">
								Mother's Name
							</label>
						</div>
						<div className="col-md-5 col-xs-12">
							<input
								className="form-control z-depth-3"
								value={userDetails.MotherName}
								onChange={(e) => {
									if (!containsNumbers(e.target.value)) {
										onChangeHandler(e)
									}
								}}
								name="MotherName"
								type="text"
								maxLength="100"
							/>
						</div>
					</div>
				</div >

				<div className="formWrapper">
					<div className="row">
						<div className="col-md-3 col-xs-12">
							<label className="appFormLabel ">
								Date of Birth
							</label>
							<span className="requiredText">*</span>
						</div>
						<div className="col-md-5 col-xs-12">
							<DatePicker
								onChange={(date) => {
									if (date) {
										const today = new Date();
										let age = today.getFullYear() - date.getFullYear();
										const m = today.getMonth() - date.getMonth();
										if (m < 0 || (m === 0 && today.getDate() < date.getDate())) {
											age--;
										}
										if (age > 80) {
											const options = { day: '2-digit', month: 'short', year: 'numeric' };
											const formattedDate = date.toLocaleDateString('en-GB', options).replace(/ /g, '-');
											setAgeConfirmData({
												show: true,
												date: date,
												msg: `The entered Date of Birth (${formattedDate}) results in an age of ${age} years. Please verify the details before proceeding.`
											});
										} else {
											DateChangeHandler(date, 'DOB', '', 'Personal');
										}
									} else {
										DateChangeHandler(date, 'DOB', '', 'Personal');
									}
								}}
								selected={userDetails.DOB}
								showMonthDropdown
								showYearDropdown
								dateFormat="dd-MMM-yyyy"
								className={
									requiredFields.commonErrors[0].DOBReqError ? (
										'form-control invalid z-depth-3'
									) : (
										'form-control z-depth-3'
									)
								}
								dropdownMode="select"
								autoComplete="off"
								placeholderText="dd-mmm-yyyy"
								maxDate={new Date()}
							/>
							{requiredFields.commonErrors[0].DOBReqError ? (
								<p className="ValidationError">
									<i className="fa fa-warning warningIcon" />Date cannot be empty
								</p>
							) : null}
						</div>
					</div>
				</div >

				<div className="formWrapper">
					<div className="row">
						<div className="col-md-3 col-xs-12">
							<label className="appFormLabel ">
								Email ID
							</label>
							<span className="requiredText">*</span>
						</div>
						<div className="col-md-5 col-xs-12">
							<input
								className={
									ValidationError.EmailError ? (
										'form-control invalid z-depth-3'
									) : (
										'form-control z-depth-3'
									)
								}
								value={userDetails.Email}
								onChange={onChangeHandler}
								name="Email"
								type="Email"
								placeholder="example@gmail.com"
								maxLength="200"
								onBlur={() => validateEmail(userDetails.Email)}
							/>
							{ValidationError.EmailError ? (
								<p className="ValidationError">
									<i className="fa fa-warning warningIcon" />Invalid email address
								</p>
							) : requiredFields.commonErrors[0].EmailReqError ? (
									<p className="ValidationError">
										<i className="fa fa-warning warningIcon" />Enter a valid Email ID.
									</p>
								) : null}
						</div>
					</div>
				</div >

				<div className="formWrapper">
					<div className="row">
						<div className="col-md-3 col-xs-12">
							<label className="appFormLabel ">
								Mobile No
							</label>
							<span className="requiredText">*</span>
						</div>
						<div className="col-md-5 col-xs-12">
							<div>
								{userDetails.CountryCode?.label === 'Other' ? (
									<div style={{ display: 'inline' }} 	>
										<input
											className={requiredFields.commonErrors[0].CountryCodeReqError ?"form-control CountryCodeInput invalid z-depth-3": "form-control CountryCodeInput z-depth-3"}
											type="text"
											name="CountryCodeEnt"
											value={userDetails.CountryCodeEnt}
											onChange={onChangeHandler}
											// placeholder='country code'
										/>
										<i
											className="fa fa-times"
											style={{ marginLeft: '5px' ,marginRight:"12px"}}
											onClick={() => GenerateRemovePopup('CountryCode')}
										/>
									</div>
								) : (
									<Select
										className="CountryDropDown"
										value={userDetails.CountryCode}
										options={CountryCodes}
										onChange={(selected) => SelectHandler(selected, 'CountryCode')}
									/>
								)}
								<input
									className={
										ValidationError.mobileNoError ||
											requiredFields.commonErrors[0].mobileNoReqError ? userDetails.CountryCode?.label === 'Other' ? (
											'PhoneInputWithIcon invalid z-depth-3'
										) : (
											'PhoneInput invalid z-depth-3'
										) : userDetails.CountryCode.label === 'Other' ? (
											'PhoneInputWithIcon  z-depth-3'
										) : (
											'PhoneInput z-depth-3'
										)
									}
									onKeyDown={ERPUtils.isValidNumber}
									value={userDetails.mobileNo}
									onChange={onChangeHandler}
									name="mobileNo"
									type="text"
									maxLength={userDetails.CountryCode?.value === '+91' ? 10 : 20}
								/>
								{ValidationError.mobileNoError ? (
									<p className="ValidationError">
										<i className="fa fa-warning warningIcon" />Please enter a valid phone number
									</p>
								) : null}
								{requiredFields.commonErrors[0].mobileNoReqError ? (
									<p className="ValidationError">
										<i className="fa fa-warning warningIcon" />Mobile No cannot be empty or invalid number.
									</p>
								) :requiredFields.commonErrors[0].CountryCodeReqError ? (
									<p className="ValidationError">
										<i className="fa fa-warning warningIcon" />Please enter valid country code.
									</p>
								): null}
							</div>
						</div>
					</div>
				</div >

				<div className="formWrapper">
					<div className="row">
						<div className="col-md-3 col-xs-12">
							<label className="appFormLabel ">
								Alternate No
							</label>
						</div>
						<div className="col-md-5 col-xs-12">
							<input
								className={
									ValidationError.AltNoError ? (
										'form-control invalid z-depth-3'
									) : (
										'form-control z-depth-3'
									)
								}
								value={userDetails.AltNo}
								onChange={onChangeHandler}
								name="AltNo"
								maxLength="20"
								onKeyDown={ERPUtils.isValidNumber}
							/>
							{ValidationError.AltNoError ? (
								<p className="ValidationError">
									<i className="fa fa-warning warningIcon" />Please enter a valid phone number
								</p>
							) : null}
							{requiredFields.commonErrors[0].AltNoReqError ? (
								<p className="ValidationError">
									<i className="fa fa-warning warningIcon" />Mobile No cannot be empty or invalid number.
								</p>
							) : null}
						</div>
					</div>
				</div >

				<div className="formWrapper">
					<div className="row">
						<div className="col-md-3 col-xs-12">
							<label className="appFormLabel ">
								Aadhar No
							</label>
						</div>
						<div className="col-md-5 col-xs-12">
							<input
								className={
									ValidationError.AadharNoError ? (
										'form-control invalid z-depth-3'
									) : (
										'form-control z-depth-3'
									)
								}
								value={userDetails.AadharNo}
								onChange={onChangeHandler}
								name="AadharNo"
								type="text"
								maxLength="12"
								onKeyDown={ERPUtils.isValidNumber}
							/>
							{/* {ValidationError.AadharNoError ? (
								<p className="ValidationError">
									<i className="fa fa-warning warningIcon" />Please enter a valid aadhar number
								</p>
							) : null}

							{requiredFields.commonErrors[0].AadharNoReqError ? (
								<p className="ValidationError">
									<i className="fa fa-warning warningIcon" />Please enter a valid aadhar number
								</p>
							) : null} */}
						</div>
					</div>
				</div >

				<div className="formWrapper">
					<div className="row">
						<div className="col-md-3 col-xs-12">
							<label className="appFormLabel ">
								Marital Status
							</label>
							<span className="requiredText">*</span>
						</div>
						<div className="col-md-5 col-xs-12">
							<Select
								className={
									requiredFields.commonErrors[0].maritalReqError ? 'invalid z-depth-3' : 'z-depth-3'
								}
								value={userDetails.marital}
								onChange={(selected) => SelectHandler(selected, 'marital')}
								options={maritalStatus}
							/>
							{requiredFields.commonErrors[0].maritalReqError ? (
								<p className="ValidationError">
									<i className="fa fa-warning warningIcon" />Marital status cannot be empty
								</p>
							) : null}
						</div>
					</div>
				</div >

				<div className="formWrapper">
					<div className="row">
						<div className="col-md-3 col-xs-12">
							<label className="appFormLabel ">
								Nationality
							</label>
							<span className="requiredText">*</span>
						</div>
						<div className="col-md-5 col-xs-12">
							<Select
								className={
									requiredFields.commonErrors[0].NationalityReqError ? (
										'invalid z-depth-3'
									) : (
										'z-depth-3'
									)
								}
								value={userDetails.Nationality}
								onChange={(selected) => SelectHandler(selected, 'Nationality')}
								options={Nationalities}
							/>
							{requiredFields.commonErrors[0].NationalityReqError ? (
								<p className="ValidationError">
									<i className="fa fa-warning warningIcon" />Nationality cannot be empty
								</p>
							) : null}
						</div>
					</div>
				</div >

				<div className="formWrapper">
					<div className="row">
						<div
							className={
								userDetails.Nationality !== '' ? userDetails.Nationality.label.toLowerCase() ===
									'indian' ? (
									'col-md-3 col-xs-12'
								) : (
									'col-md-3 col-xs-12'
								) : (
									'col-md-3 col-xs-12'
								)
							}
						>
							<label className="appFormLabel ">
								Passport No
							</label>
							{userDetails.Nationality !== '' ? isPassportRequired ? null : (
								<span className="requiredText">*</span>
							) : null}
							{/* {userDetails.Nationality !== '' ? userDetails.Nationality.label.toLowerCase() ===
								'indian' ? null : (
								<span className="requiredText">*</span>
							) : null} */}
						</div>
						<div className="col-md-5 col-xs-12">
							<input
								className={
									requiredFields.commonErrors[0].PassportNoReqError ? (
										'form-control invalid z-depth-3'
									) : (
										'form-control z-depth-3'
									)
								}
								value={userDetails.PassportNo}
								onChange={onChangeHandler}
								name="PassportNo"
								type="text"
								maxLength="20"
								onKeyDown={ERPUtils.validateSpecialCharacterInput}
							/>
							{requiredFields.commonErrors[0].PassportNoReqError ? (
								<p className="ValidationError">
									<i className="fa fa-warning warningIcon" />Passport No cannot be empty
								</p>
							) : null}
						</div>
					</div>
				</div >

				<div className="formWrapper">
					<div className="row">
						<div className="col-md-3 col-xs-12">
							<label className="appFormLabel">
								Religion
							</label>
							<span className="requiredText ">*</span>
						</div>
						<div className="col-md-5 col-xs-12">
							<Select
								className={
									requiredFields.commonErrors[0].ReligionReqError ? 'invalid z-depth-3' : 'z-depth-3'
								}
								value={userDetails.Religion}
								onChange={(selected) => SelectHandler(selected, 'Religion')}
								options={Religions}
							/>
							{requiredFields.commonErrors[0].ReligionReqError ? (
								<p className="ValidationError">
									<i className="fa fa-warning warningIcon" />Religion cannot be empty
								</p>
							) : null}
						</div>
					</div>
				</div >

				<div className="formWrapper">
					<div className="row">
						<div className="col-md-3 col-xs-12">
							<label className="appFormLabel ">
								Minority
							</label>
						</div>
						<div className="col-md-5 col-xs-12" style={{ top: '12px' }}>
							<label style={{ padding: '0px 10px' }}>{userDetails.Minority}</label>
						</div>
					</div>
				</div >

				<div className="formWrapper">
					<div className="row">
						<div className="col-md-3 col-xs-12">
							<label className="appFormLabel ">
								Reservation Category
							</label>
							<span className="requiredText">*</span>
						</div>
						<div className="col-md-5 col-xs-12">
							<Select
								className={
									requiredFields.commonErrors[0].ReservationReqError ? (
										'invalid z-depth-3'
									) : (
										'z-depth-3'
									)
								}
								value={userDetails.Reservation}
								onChange={(selected) => SelectHandler(selected, 'Reservation')}
								options={Reservations}
							/>
							{requiredFields.commonErrors[0].ReservationReqError ? (
								<p className="ValidationError">
									<i className="fa fa-warning warningIcon" />Reservation cannot be empty
								</p>
							) : null}
						</div>
					</div>
				</div >

				<div className="formWrapper">
					<div className="row">
						<div className="col-md-3 col-xs-12">
							<label className="appFormLabel ">
								Blood Group
							</label>
						</div>
						<div className="col-md-5 col-xs-12">
							<Select
								className="z-depth-3"
								value={userDetails.BloodGroup}
								onChange={(selected) => SelectHandler(selected, 'BloodGroup')}
								options={bloodGroups}
								maxMenuHeight={180}
								menuPlacement="auto"
								isClearable
							/>
						</div>
					</div>
				</div >

				<div className="formWrapper">
					<div className="row">
						<div className="col-md-3 col-xs-12">
							<label className="appFormLabel ">
								Differently Abled
							</label>
						</div>
						<div
							className={userDetails.DiffAbled === 'Yes' ? 'col-md-2 col-xs-12' : 'col-md-4 col-xs-12'}
							style={{ top: '12px' }}
						>
							<label className="radio-inline">
								<input
									onChange={onChangeHandler}
									className="space"
									type="radio"
									name="DiffAbled"
									value="Yes"
									checked={userDetails.DiffAbled === 'Yes'}
								/>Yes
							</label>
							<label className="radio-inline">
								<input
									onChange={onChangeHandler}
									className="space"
									type="radio"
									name="DiffAbled"
									value="No"
									checked={userDetails.DiffAbled === 'No'}
								/>No
							</label>
						</div>
						{userDetails.DiffAbled === 'Yes' ? (
							<div className="col-md-3">
								<Select
									className="diffrentlyAbledSelect"
									value={userDetails.DifferentlyAbledType}
									onChange={(selected) => SelectHandler(selected, 'DifferentlyAbledType')}
									options={DifferentlyAbledOpt}
									menuPlacement='auto'
								/>
							</div>
						) : null}
					</div>
				</div >

				<br />
				<div className="formWrapper">
					<div className="row">
						<div className="col-sm-4 parentDiv">
							<button
								name="RoleDetails"
								className="PreviousButton z-depthButton"
								value="Previous"
								onClick={()=>handleRenderComp("RoleDetails")}
							>
								<i className="fas fa-chevron-left mr-3" style={{ color: "#ffffff" }}></i>
								Previous
							</button>
						</div>
						<div className="col-sm-4 parentDiv">
							<button
								className="saveDraftButton z-depthButton"
								value="Save Draft"
								name="SaveDraft"
								onClick={saveDraft}
							>
								Save Draft
							</button>
						</div>
						<div className="col-sm-4 parentDiv">
							<button
								className="nextButton z-depthButton"
								value="Next"
								name="AddressDetails"
								onClick={()=>handleRenderComp("AddressDetails")}
							>
								Next
								<i className="fas fa-chevron-right ml-4 mt-1" style={{ color: "#ffffff" }}></i>
							</button>
						</div>
					</div>
				</div>
				<div>
					<button onClick={topFunction} id="myBtnUp">
						<div className="UpArrow" />
					</button>
					<button onClick={scrollToBottom} id="myBtnDown">
						<div className="downArrow" />
					</button>
				</div>
			</div >
			{ageConfirmData.show ? (
				<ConfirmPopup
					open={ageConfirmData.show}
					title="WARNING"
					confirm={() => {
						DateChangeHandler(ageConfirmData.date, 'DOB', '', 'Personal');
						setAgeConfirmData({ show: false, date: null, msg: '' });
					}}
					cancel={() => setAgeConfirmData({ show: false, date: null, msg: '' })}
					msg={ageConfirmData.msg}
					tabName="Personal"
				/>
			) : null}
		</div >
	);
};

export default PersonalDetails;
